@if (participantAuthKey(); as key) {
  <shared-client-conversation [participantAuthKey]="key" (reloadRequested)="reload()" />
}
